export const nextFrame = (): Promise<void> =>
  new Promise(resolve => {
    window.requestAnimationFrame(() => resolve())
  })

/**
 * Resolves once every `<img>` in the subtree has loaded (or failed) and
 * decoded. Errors resolve rather than reject: a missing decorative image
 * should degrade the PDF, not abort the export.
 *
 * Only covers `<img>` -- CSS `background-image` decode is not observable,
 * which is why the template renders the header background as an `<img>`
 * layer rather than a CSS background.
 */
export const waitForImages = async (root: HTMLElement): Promise<void> => {
  const images = Array.from(root.querySelectorAll('img'))

  await Promise.all(
    images.map(
      image =>
        new Promise<void>(resolve => {
          if (image.complete) {
            resolve()
            return
          }
          image.addEventListener('load', () => resolve(), { once: true })
          image.addEventListener('error', () => resolve(), { once: true })
        }),
    ),
  )

  await Promise.all(images.map(image => image.decode?.().catch(() => undefined)))
}
